import React, { useRef } from 'react'
import Button from 'components/Button'
import styles from './home.module.scss'
// import Gallery from '../Gallery/index'
import Invitation from '../Invitation/index'
import WayTo from '../WayTo/index'
// import Message from '../Message/index'
import NewGallery from '../Gallery/NewGallery'
// import Modal from 'components/Modal'
// import { useModal } from 'hooks/useModal'

const Home: React.FC = () => {
  const wayToRef = useRef<HTMLDivElement>(null)
  const invitationRef = useRef<HTMLDivElement>(null)
  const galleryRef = useRef<HTMLDivElement>(null)
  // const { isModalOpen, openModal, closeModal } = useModal()

  // useEffect(() => {
  //   return () => setCopiedPerson('')
  // }, [isModalOpen])

  // useEffect(() => {
  //   if (!isModalOpen) {
  //     openModal()
  //   }
  //   // if (wayToRef.current) {
  //   //   scrollToRef(wayToRef)
  //   // }
  // }, [])

  const scrollToRef = (ref: React.RefObject<HTMLDivElement>) => {
    if (ref.current) {
      const offsetTop = ref.current.offsetTop - 100 // 메뉴바 높이만큼 오프셋을 조정합니다.
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth',
      })
    }
  }

  return (
    <div className='mb-24'>
      {/* {isModalOpen && (
        <Modal title='감사인사' closeModal={closeModal}>
          <p>준비 기간이 촉박하여</p>
          <p>직접 찾아뵙고 인사드리지 못해 송구합니다.</p>
          <br />
          <p>그럼에도 따뜻한 축하와 마음을 전해주셔서</p>
          <p>진심으로 감사드립니다.</p>
          <p>보내주신 마음 오래도록 간직하며</p>
          <p>서로를 아끼고 행복하게 살아가겠습니다.</p>
          <br />
          <button
            type='button'
            className='text-white bg-gray-800 hover:bg-gray-900 focus:outline-none focus:ring-4 focus:ring-gray-300 font-medium rounded-full text-lg px-5 py-2.5 me-2 mb-2 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700 dark:border-gray-700'
            onClick={() => {
              closeModal()
            }}
          >
            닫기
          </button>
        </Modal>
      )} */}
      {/* <div className='fixed inset-x-0 flex justify-center mt-10 bottom-8'> */}
      <div className='fixed inset-x-0 z-50 mt-10 bottom-8 flex justify-center'>
        <div className={styles.shortcutBar}>
          <div className={styles.shortcutButtonGroup}>
            <Button
              className={styles.fadeIn}
              style={{ animationDelay: '500ms' }}
              text='초대글'
              size='large'
              onClick={() => scrollToRef(invitationRef)}
            />
            <Button
              className={styles.fadeIn}
              style={{ animationDelay: '500ms' }}
              text='오시는길'
              size='large'
              onClick={() => scrollToRef(wayToRef)}
            />
            <Button
              className={styles.fadeIn}
              style={{ animationDelay: '500ms' }}
              text='사진첩'
              size='large'
              onClick={() => scrollToRef(galleryRef)}
            />
          </div>
        </div>
      </div>
      <div ref={invitationRef}>
        <Invitation />
      </div>
      <div ref={wayToRef}>
        <WayTo />
      </div>
      <div ref={galleryRef}>
        {/* <Gallery /> */}
        <NewGallery />
      </div>
      {/* <div ref={messageRef}>
        <Message />
      </div> */}
    </div>
  )
}

export default Home
